export const initialState = {
  devFeaturesEnabled: false,
  showDisabledUsers: false,
};

export default initialState;
